"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._useSimulatedButton = _useSimulatedButton;
const react_1 = require("react");
function _useSimulatedButton({ analyticsCallback, isClickable, isHyperlink, onClick, onKeyDown, onKeyUp, isSubmitType, }) {
    const _onClick = (0, react_1.useCallback)((e) => {
        var _a;
        if ((isClickable || isHyperlink) && analyticsCallback) {
            analyticsCallback();
        }
        if (isClickable) {
            if (isSubmitType) {
                const closestForm = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.closest("form");
                if (closestForm) {
                    closestForm.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
                }
            }
            if (onClick) {
                onClick(e);
            }
        }
        else {
            e.preventDefault();
        }
    }, [analyticsCallback, isClickable, isHyperlink, onClick, isSubmitType]);
    const _onKeyUp = (0, react_1.useCallback)((e) => {
        if (isClickable && (e.key === "Enter" || e.key === " ")) {
            e.target.dispatchEvent(new MouseEvent("click", {
                bubbles: true,
                buttons: 1,
                cancelable: true,
                view: window,
            }));
            if (onKeyUp) {
                onKeyUp(e);
            }
        }
    }, [isClickable, onKeyUp]);
    const _onKeyDown = (0, react_1.useCallback)((e) => {
        if (isClickable && e.key === " ") {
            e.preventDefault();
            if (onKeyDown) {
                onKeyDown(e);
            }
        }
    }, [isClickable, onKeyDown]);
    return { onClick: _onClick, onKeyDown: _onKeyDown, onKeyUp: _onKeyUp };
}
